import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_DESCRIPTION =
    "Accurate Aurora forecasts, maps, alerts and information for locations around the world";

const ROUTE_META: Record<string, { title: string; description?: string }> = {
    "/": {
        title: "Aurora Forecaster",
        description: DEFAULT_DESCRIPTION,
    },
    "/advanced-dashboard": {
        title: "Space weather — Aurora Forecaster",
        description: "Live satellite solar wind, magnetometer, and space weather data.",
    },
    "/forecast": {
        title: "Long-term forecast — Aurora Forecaster",
        description: "Hour-by-hour aurora predictions for the next three days.",
    },
    "/map": {
        title: "Aurora map — Aurora Forecaster",
        description: "Aurora visibility map with viewing locations, reports, and darkness overlays.",
    },
    "/photography": {
        title: "Photography guide — Aurora Forecaster",
        description: "Camera and phone settings for photographing the aurora.",
    },
    "/latest-submissions": {
        title: "Latest reports — Aurora Forecaster",
        description: "Recent community aurora and cloud reports.",
    },
    "/submit-report": {
        title: "Submit a report — Aurora Forecaster",
        description: "Report aurora sightings or cloud cover to help others tonight.",
    },
    "/settings": { title: "Settings — Aurora Forecaster" },
    "/admin": { title: "Admin — Aurora Forecaster" },
    "/status": {
        title: "Data status — Aurora Forecaster",
        description: "Admin view of satellite, magnetometer, and model data freshness.",
    },
    "/privacy": { title: "Privacy policy — Aurora Forecaster" },
    "/cookies": { title: "Cookie policy — Aurora Forecaster" },
    "/terms": { title: "Terms of service — Aurora Forecaster" },
    "/success": { title: "Subscription active — Aurora Forecaster" },
};

export function PageMeta() {
    const { pathname } = useLocation();

    useEffect(() => {
        const meta = ROUTE_META[pathname] ?? { title: "Aurora Forecaster" };
        document.title = meta.title;

        const description = meta.description ?? DEFAULT_DESCRIPTION;
        const tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
        if (tag) tag.content = description;
    }, [pathname]);

    return null;
}
